import React from "react";
import { Busy } from "../presentational/busy";
import { Card } from "../presentational/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import { faMinus } from "@fortawesome/pro-light-svg-icons/faMinus";
import { faPlus } from "@fortawesome/pro-light-svg-icons/faPlus";
import { faCheckSquare } from "@fortawesome/pro-light-svg-icons/faCheckSquare";
import { faSquare } from "@fortawesome/pro-light-svg-icons/faSquare";
import ReactGA from "react-ga";
import styles from "../../styles/panels/charityDistribution.css";
import "rc-slider/assets/index.css";
import * as utilities from "../../middleware/utilities";

export class CharityDistribution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/CharityDistribution");
    utilities
      .isCodeValid(this.props.code)
      .then(valid => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }

  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          <div
            className={styles.icon}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/CharityDistribution"
              });
              this.props.onBack();
            }}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} />
          </div>
          {this.props.dictionary.charity_distribution_header}
        </div>
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <div className={styles.commands}>
          <button
            className={styles.button}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/CharityDistribution"
              });
              this.props.onBack();
            }}
          >
            {this.props.dictionary.charity_distribution_back}
          </button>
          <button
            className={styles.button + " " + styles.primary}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Continue Button",
                label: "/Spend/CharityDistribution"
              });
              this.props.onContinue();
            }}
          >
            {this.props.dictionary.charity_distribution_continue}
          </button>
        </div>
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
      </div>
    );
  }

  renderTotalError(difference) {
    if (this.props.totalValid) {
      return null;
    } else {
      return (
        <div className={styles.errorAmountMessage}>
          {difference > 0 ? (
            <div>
              {this.props.validation.charity_distribution_input_total_low
                .replace(
                  "{Total}",
                  this.props.donation.amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                  })
                )
                .replace(
                  "{Difference}",
                  difference < 1
                    ? difference.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                      })
                    : Math.trunc(difference).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0
                      })
                )}
            </div>
          ) : (
            <div>
              {this.props.validation.charity_distribution_input_total_high
                .replace(
                  "{Total}",
                  this.props.donation.amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                  })
                )
                .replace(
                  "{Difference}",
                  difference > -1
                    ? (difference * -1).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                      })
                    : Math.trunc(difference * -1).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0
                      })
                )}
            </div>
          )}
        </div>
      );
    }
  }
  renderBoundError() {
    if (this.props.inBoundsValid) {
      return null;
    } else {
      return (
        <div className={styles.errorAmountMessage}>
          {this.props.validation.charity_distribution_input_total_out_of_bounds}
        </div>
      );
    }
  }
  renderReset() {
    if (this.props.totalValid && this.props.inBoundsValid) {
      return null;
    } else {
      return (
        <div className={styles.errorAmountMessage}>
          <div
            className={styles.reset}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Reset Button",
                label: "/Spend/CharityDistribution"
              });
              this.props.onReset();
            }}
          >
            {this.props.dictionary.charity_distribution_reset}
          </div>
        </div>
      );
    }
  }

  renderCharities() {
    let total = this.props.selectedCharities.reduce((a, b) => ({
      amount: a.amount + b.amount
    }));
    let difference = this.props.donation.amount - total.amount;
    return (
      <div
        className={
          styles.charities + (this.props.totalValid ? "" : " " + styles.error)
        }
      >
        {this.renderTotalError(difference)}
        {this.renderBoundError()}
        {this.renderReset()}
        {this.props.selectedCharities.map(charity => {
          return (
            <div className={styles.charity} key={charity.ein}>
              <div className={styles.leftSpace}>
                <img
                  src={charity.image}
                  title={charity.title}
                  className={
                    styles.image +
                    (this.props.selectedCharities.length > 1
                      ? ""
                      : " " + styles.singleImage)
                  }
                />
              </div>
              <div className={styles.rightSpace}>
                {this.props.selectedCharities.length > 1 ? (
                  <div>
                    <div
                      className={styles.minus}
                      onClick={() => {
                        ReactGA.event({
                          category: "User Action",
                          action: "Clicked Minus Button",
                          label: "/Spend/CharityDistribution"
                        });
                        this.props.onCharityChanged(
                          charity.amount > 3 ? charity.amount - 1 : 3,
                          charity.ein
                        );
                      }}
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </div>
                    $
                    <input
                      className={styles.amountInput}
                      type="number"
                      min="3"
                      max={
                        this.props.donation.amount -
                        (this.props.selectedCharities.length - 1) * 3
                      }
                      value={charity.amount}
                      onChange={event => {
                        this.props.onCharityChanged(
                          event.target.value,
                          charity.ein
                        );
                      }}
                    />
                    {charity.cents > 0
                      ? (charity.cents + "0").slice(1, 4)
                      : null}
                    <div
                      className={styles.plus}
                      onClick={() => {
                        ReactGA.event({
                          category: "User Action",
                          action: "Clicked Plus Button",
                          label: "/Spend/CharityDistribution"
                        });
                        this.props.onCharityChanged(
                          charity.amount + 1,
                          charity.ein
                        );
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </div>
                  </div>
                ) : (
                  <div className={styles.amountDisplay}>
                    {(charity.amount + charity.cents).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 2
                    })}
                  </div>
                )}
                <div className={styles.name}>{charity.name}</div>
              </div>
            </div>
          );
        })}
        {this.renderTotalError(difference)}
        {this.renderBoundError()}
      </div>
    );
  }

  renderOptIn() {
    return (
      <div className={styles.stayInformed}>
        <div>
          <div
            className={styles.optIn}
            onClick={event => {
              this.props.onOptInChanged(!this.props.optIn);
            }}
          >
            {this.props.optIn ? (
              <FontAwesomeIcon icon={faCheckSquare} />
            ) : (
              <FontAwesomeIcon icon={faSquare} />
            )}
          </div>
          {this.props.dictionary.charity_distribution_stay_informed}
        </div>
        <div className={styles.group}>
          <label
            className={
              styles.inputLabel +
              (this.props.nameValid ? "" : " " + styles.error)
            }
          >
            {this.props.dictionary.charity_distribution_input_name}
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.nameInput +
              (this.props.nameValid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.name}
            onChange={event => {
              this.props.onNameChanged(event.target.value);
            }}
          />
          {this.props.nameValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.charity_distribution_input_name}
            </div>
          )}
        </div>
        <div className={styles.group}>
          <label
            className={
              styles.inputLabel +
              (this.props.emailValid ? "" : " " + styles.error)
            }
          >
            {this.props.dictionary.charity_distribution_input_email}
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.emailInput +
              (this.props.emailValid ? "" : " " + styles.error)
            }
            type="email"
            value={this.props.email}
            onChange={event => {
              this.props.onEmailChanged(event.target.value);
            }}
          />
          {this.props.emailValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.charity_distribution_input_email}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.renderNavigation()}
          <div className={styles.content}>
            <div className={styles.information}>
              {this.props.dictionary.charity_distribution_message}
            </div>
            {this.renderCharities()}
            <div className={styles.totalAmount}>
              {this.props.dictionary.charity_distribution_donation_amount}
              <div className={styles.amount}>
                {this.props.donation.amount.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2
                })}
              </div>
            </div>
            {this.props.selectedCharities.length > 1 ? (
              <div className={styles.note}>
                {this.props.dictionary.charity_distribution_note}
              </div>
            ) : null}
            {this.renderOptIn()}
          </div>
          {this.renderAside()}
        </div>
      );
    }
  }
}
